import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Button, Stack } from "@mui/material";

import { ROUTES } from "../Util/RouteConstants";
import PageContainer from "../Components/PageContainer";
import useUsers from "../hooks/useUsers";
import UserDetailsContent from "../Components/UserDetailsContent";
import { ApiResponse } from "../api/dataTypes";
import FormSubmitStatus from "../Components/FormSubmitStatus";
import { setSnackbarSuccessMessage } from "../Components/SessionStorageSnackbar";

export default function UserDetails(): JSX.Element {
  const { id } = useParams();
  const navigate = useNavigate();
  const { deleteUser, fetchUser, getUserById } = useUsers();
  const [deleteApiResponse, setDeleteApiResponse] = useState<ApiResponse>();

  const user = getUserById(id as string);

  useEffect(() => {
    fetchUser(id as string);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user)
    return <Alert severity="error">User {id} could not be found</Alert>;

  const displayObject: any = { ...user };
  delete displayObject.name;
  delete displayObject.organization;

  return (
    <PageContainer
      title="User Details"
      actionButton={
        <Stack alignItems="flex-end" spacing={2}>
          <Stack direction="row" spacing={2}>
            <Button
              onClick={() =>
                navigate(
                  ROUTES.ADMIN_USERS_ID_EDIT.route.replace(":id", id as string)
                )
              }
              variant="outlined"
            >
              Edit
            </Button>
            <Button
              color="error"
              onClick={async () => {
                if (
                  window.confirm(`Delete user ${user.name} (${user.email})?`)
                ) {
                  const response: ApiResponse = await deleteUser(id as string);
                  setDeleteApiResponse(response);
                  if (!response.isError) {
                    setSnackbarSuccessMessage();
                    navigate(-1);
                  }
                }
              }}
              variant="outlined"
            >
              Delete
            </Button>
          </Stack>
          <FormSubmitStatus response={deleteApiResponse} />
        </Stack>
      }
    >
      <UserDetailsContent user={user} />
    </PageContainer>
  );
}
